module.exports = __webpack_public_path__ + "static/media/image-10.a7ba9eca.webp";